// Fall-Kategorien-Baum (Iteration 2)

export const CASE_CATEGORIES = [
  {
    id: "verkehrsrecht",
    label: "Verkehrsrecht",
    children: [
      { id: "unfallregulierung", label: "Unfallregulierung" },
      { id: "fuehrerscheinentzug", label: "Führerscheinentzug" },
      { id: "verkehrsstrafrecht", label: "Verkehrsstrafrecht" },
    ],
  },
  {
    id: "arbeitsrecht",
    label: "Arbeitsrecht",
    children: [
      { id: "kuendigung-arbeit", label: "Kündigung" },
      { id: "abmahnung", label: "Abmahnung" },
      { id: "arbeitsvertrag", label: "Arbeitsvertrag" },
    ],
  },
  {
    id: "mietrecht",
    label: "Mietrecht",
    children: [
      { id: "kuendigung-miete", label: "Kündigung" },
      { id: "mietminderung", label: "Mietminderung" },
      { id: "raeumungsklage", label: "Räumungsklage" },
    ],
  },
  {
    id: "strafrecht",
    label: "Strafrecht",
    children: [],
  },
  {
    id: "familien-erbrecht",
    label: "Familien- & Erbrecht",
    children: [
      { id: "testament", label: "Testament" },
      { id: "vorsorgevollmacht", label: "Vorsorgevollmacht" },
      { id: "scheidung", label: "Scheidung" },
      { id: "unterhalt", label: "Unterhalt" },
      { id: "sorgerecht", label: "Sorgerecht" },
      { id: "pflichtteil", label: "Pflichtteil" },
      { id: "erbschein", label: "Erbschein" },
    ],
  },
  {
    id: "vertragsrecht",
    label: "Vertragsrecht",
    children: [
      { id: "vertragspruefung", label: "Vertragsprüfung" },
      { id: "vertragserstellung", label: "Vertragserstellung" },
      { id: "vertragskuendigung", label: "Vertragskündigung" },
    ],
  },
  {
    id: "zivilrecht",
    label: "Zivilrecht",
    children: [
      { id: "forderungsbeitreibung", label: "Forderungsbeitreibung" },
      { id: "forderungsabwehr", label: "Forderungsabwehr" },
      { id: "schadensersatz", label: "Schadensersatz" },
      { id: "schmerzensgeld", label: "Schmerzensgeld" },
    ],
  },
  {
    id: "bussgeld",
    label: "Bußgeld",
    children: [
      { id: "bussgeld-verkehr", label: "Bußgeld Verkehr" },
      { id: "bussgeld-ordnungswidrigkeit", label: "Ordnungswidrigkeit (sonstige)" },
    ],
  },
  {
    id: "nachbarschaftsstreit",
    label: "Nachbarschaftsstreit",
    children: [],
  },
  {
    id: "sonstige",
    label: "Sonstige",
    children: [],
  },
];
